const env = process.env.NODE_ENV || 'development'

const config = {
  development: {
    baseURL: 'http://192.168.11.103:19091/nmequityagent'//本地
    // baseURL: 'https://equity.aojuai.com/nmequityagent'//线上
  },
  production: {
    baseURL: 'https://equity.aojuai.com/nmequityagent'
  }
}
export default config[env] || config.development
